import { isDevelopment, isTest } from "../constants/env";

/**
 * The CF_Authorization cookie is set by the Cloudflare when we access on the super admin page.
 */
const CFAUTH_COOKIE_NAME = "CF_Authorization";

export const getCookieByName = (name: string) => {
  if (typeof document === "undefined") {
    return;
  }
  const cookies = document.cookie.split("; ");
  return cookies.find((cookie) => cookie.includes(name))?.split(`${name}=`)?.[1];
};

export const isAuthenticatedAsSuperAdmin = () => {
  return isDevelopment || isTest ? false : !!getCookieByName(CFAUTH_COOKIE_NAME);
};

export const removeCFAuthCookie = () => {
  if (typeof document === "undefined") {
    return;
  }
  // To remove a cookie, we rewrite it with a past expiration date
  document.cookie = `${CFAUTH_COOKIE_NAME}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
};

export const applyCFAuthHeader = () => {
  //We fake the cf authorization token in test environment to help debug
  const cfCookie = isDevelopment || isTest ? "test_cookie" : getCookieByName(CFAUTH_COOKIE_NAME);
  return {
    headers: {
      ...(cfCookie && { authorization: cfCookie }),
    },
  };
};

export const setEnableAuthenticatorCookie = () => {
  if (typeof document === "undefined") {
    return;
  }
  // Set cookie with 1 year expiration
  const expires = new Date();
  expires.setFullYear(expires.getFullYear() + 1);
  document.cookie = `enableAuthenticator=true; expires=${expires.toUTCString()}; path=/;`;
};

export const removeEnableAuthenticatorCookie = () => {
  if (typeof document === "undefined") {
    return;
  }
  // To remove a cookie, we rewrite it with a past expiration date
  document.cookie = `enableAuthenticator=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
};
